import * as React from 'react';
import * as Constants from 'src/constants';
import * as Layout from 'src/components/Layout';
import NavBar from 'src/views/Marketing/components/NavBar';
import Footer from 'src/views/Marketing/components/Footer';
import { ScrollView, StyleSheet, Text, View } from 'react-native';

interface PropsIface {
  inApp?: boolean;
}

const Screen: React.FC<PropsIface> = (props) => {
  return (
    <>
      <ScrollView style={styles.scrollView}>
        {!Boolean(props.inApp) ? <NavBar /> : null}
        <Layout.EdgeGutter style={styles.contentContainerStyle}>
          <View style={styles.pricingMethodRow}>
            <View style={[styles.pricingMethodColumn, Constants.GridStyle.MB4Unit]}>
              <View style={Constants.GridStyle.MB4Unit}>
                <Text style={[Constants.TextStyle.T42B, Constants.TextStyle.ACenter]}>{'One single subscription'}</Text>
                <Text style={[Constants.TextStyle.T24R, Constants.TextStyle.CDarkGray, Constants.TextStyle.ACenter]}>
                  {'OneShop Premium gets you access to the most powerful platform for selling on marketplaces.'}
                </Text>
              </View>
              <View style={Constants.GridStyle.MB4Unit}>
                <Text style={[Constants.TextStyle.T42B, Constants.TextStyle.ACenter]}>{'$45/month'}</Text>
              </View>
            </View>
          </View>
        </Layout.EdgeGutter>
        {!Boolean(props.inApp) ? <Footer /> : null}
      </ScrollView>
    </>
  );
};

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
  contentContainerStyle: {
    paddingTop: 6 * Constants.Grid.dp(12),
  },
  pricingMethodRow: {
    alignItems: 'center',
  },
  pricingMethodColumn: {
    maxWidth: Constants.Grid.dp(640),
    flex: 1,
    alignItems: 'center',
  },
});

export default Screen;
